import { FC, useContext } from 'react'
import { EditableCellCtx } from '../../../../../../components/editable-cell/editable-cell'
import { Form, InputNumber } from 'antd'

interface AccumulationProps {}

const Accumulation: FC<AccumulationProps> = () => {
    const ctx = useContext(EditableCellCtx)
    return (
        <Form.Item name={'accumulation'} noStyle>
            <InputNumber autoFocus onBlur={ctx.onBlur} controls={false} />
        </Form.Item>
    )
}

export default Accumulation
